import { Zappyrent } from '@zappyrent/hundop';
import { useParams } from 'react-router-dom';

import { StyledLink, StyledWrapper } from './Logo.styles';

const Logo = (): JSX.Element => {
  const { locale } = useParams();

  return (
    <StyledWrapper>
      <StyledLink
        href={`${process.env.REACT_APP_SITE_URL}/${locale}/refer-a-landlord`}
        title="Zappyrent"
      >
        <Zappyrent user="landlord" />
      </StyledLink>
    </StyledWrapper>
  );
};

export default Logo;
